import { Cell, Heading, InfoLabel } from 'bold-ui'
import { descriptions } from 'components/form/field/select/RendaFamiliarSelectField'
import { format } from 'date-fns'

interface FamiliaSectionHeaderProps {
  nomeResponsavel: string
  numeroProntuarioFamiliar: string
  rendaFamiliar: string
  resideDesde?: LocalDate
  numeroMembros?: number
  nomeEquipe?: string
  isProntuarioFamiliar?: boolean
}

export const FamiliaSectionHeader = (props: FamiliaSectionHeaderProps) => {
  const {
    nomeResponsavel,
    numeroProntuarioFamiliar,
    rendaFamiliar,
    resideDesde,
    numeroMembros,
    nomeEquipe,
    isProntuarioFamiliar,
  } = props

  return (
    <>
      <Cell size={12}>
        <Heading level={3}>
          {nomeResponsavel ? `Família de ${nomeResponsavel}` : 'Família sem responsável cadastrado'}
          {isProntuarioFamiliar && numeroProntuarioFamiliar && `| N° prontuário ${numeroProntuarioFamiliar}`}
        </Heading>
      </Cell>
      <Cell size={3}>
        {isProntuarioFamiliar ? (
          <InfoLabel title='Equipe responsável'>{nomeEquipe ?? 'Sem equipe'}</InfoLabel>
        ) : (
          <InfoLabel placeholder='Não informado' title='Nº do prontuário familiar'>
            {numeroProntuarioFamiliar}
          </InfoLabel>
        )}
      </Cell>
      <Cell size={3}>
        <InfoLabel placeholder='Não informado' title='Renda familiar'>
          {descriptions[rendaFamiliar]}
        </InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel placeholder='Não informado' title='N° de membros declarados da família'>
          {numeroMembros}
        </InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel placeholder='Não informado' title='Reside desde'>
          {resideDesde && format(new Date(resideDesde), 'MM/yyyy')}
        </InfoLabel>
      </Cell>
    </>
  )
}
